import { useMemo } from "react";
import { useBuyerReviewTasks } from "./useBuyerReviewTasks";
import { useMenuGapTasks } from "./useMenuGapTasks";
import { useInventoryCleanupTasks } from "./useInventoryCleanupTasks";
import { useStaleInventoryTasks } from "./useStaleInventoryTasks";

export function useTaskHubCounts(userId, enabled) {
  const { tasks: buyerTasks } = useBuyerReviewTasks(userId, enabled);
  const { tasks: menuGapTasks } = useMenuGapTasks(userId, enabled);
  const { tasks: cleanupTasks } = useInventoryCleanupTasks(userId, enabled);
  const { tasks: staleTasks } = useStaleInventoryTasks(userId, enabled);

  return useMemo(
    () => ({
      buyer: buyerTasks.length,
      menuGap: menuGapTasks.length,
      cleanup: cleanupTasks.length,
      stale: staleTasks.length,
      total: buyerTasks.length + menuGapTasks.length + cleanupTasks.length + staleTasks.length,
    }),
    [buyerTasks.length, menuGapTasks.length, cleanupTasks.length, staleTasks.length]
  );
}
